<template>
  <inertia-link :href="'/'">
    <img src="/images/logo.svg" class="h-16" alt="" />
  </inertia-link>
</template>
